const initialState = {
	userData: {},
	token: '',
	locale: 'en',
	isAuth: false,
}

const auth = (state = initialState, action) => {
	switch (action.type) {
		case 'LOGIN':
			return {
				...state,
				userData: action.data,
				token: action.token,
				isAuth: true,
			}
		case 'LOGOUT':
			return { ...state, userData: {}, isAuth: false }
		case 'LOCALE':
			return { ...state, locale: action.data }
		default:
			return state
	}
}

export default auth
